// What the details panel shows for a ticket, built from its detail: the ticket view, Review and
// Follow-ups all use this, so one ticket reads the same wherever it is opened.

import { similarTicketsFromApi } from '@/adapters/sentinelWorkspace.adapter';
import {
  customerFromTrace,
  ordersFromApprovals,
  ordersFromTrace,
  storefrontFromOrder,
  subscriptionPanels,
  subscriptionsFromApprovals,
  subscriptionsFromTrace,
  visibleTraceSteps,
  withApprovedAddresses,
  withCancelledOrders,
  withCancelledSubscriptions,
} from './provider-panels';
import type { SentinelConversation, SentinelWorkspaceDetailWireDto, TraceStep } from './types';

export function detailsPanelInputs({
  conversation,
  detail,
  toolTrace,
  connectedSubscriptions,
}: {
  conversation: SentinelConversation;
  detail: SentinelWorkspaceDetailWireDto | null | undefined;
  toolTrace: TraceStep[];
  /** The brand's integrations: null while loading, undefined if the lookup failed. */
  connectedSubscriptions: string[] | null | undefined;
}) {
  const events = detail?.aiEventLogs ?? [];
  const orders = [...ordersFromTrace(toolTrace), ...ordersFromApprovals(events)];
  const withAddresses = withApprovedAddresses(storefrontFromOrder(conversation.order, orders, customerFromTrace(toolTrace)), events, toolTrace);
  const storefront = withCancelledOrders(withAddresses, events, toolTrace);
  // Wait for the brand's integrations, so a card never shows under one provider and then another.
  const subscriptions =
    connectedSubscriptions === null
      ? []
      : withCancelledSubscriptions(
          subscriptionPanels(conversation.subscriptions, [
            ...subscriptionsFromTrace(toolTrace, connectedSubscriptions ?? undefined),
            ...subscriptionsFromApprovals(events, toolTrace, connectedSubscriptions ?? undefined),
          ]),
          toolTrace,
        );
  const trace = visibleTraceSteps(toolTrace, detail?.ticket.active_generation_request_id, connectedSubscriptions ?? undefined);
  // Brahma names the RAG matches on the turns the detail payload already carries.
  const similarTickets = similarTicketsFromApi(events);
  return { storefront, subscriptions, trace, similarTickets };
}
